//商品ページのSwiper
var mySwiper_products = new Swiper(".mySwiper_products", {
    loop: true,
    slidesPerView: 1,
    //effect: "fade",//
    //autoplay: {
    //delay: 5000,
    //disableOnInteraction: false,
    //},
    pagination: {
      el: ".swiper-pagination",
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    fadeEffect: {
    crossFade: true // クロスフェードさせる
  },
  });

//トップスライダー
var topSlider = new Swiper(".topSlider", {
    loop: true,
    slidesPerView: 1,
    effect: "fade",
    autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    fadeEffect: {
    crossFade: true // クロスフェードさせる
  },
  });

//ヘッダー高さを計算して横をトリミングしてトップイメージを画面全体に表示
//window.addEventListener('resize', adjustTopImageHeight);

//function adjustTopImageHeight() {
//  const headerHeight = document.querySelector('.shopify-section--header').offsetHeight;
//  document.querySelector('.topSlider').style.height = `calc(100vh - ${headerHeight}px)`;
//}

// 初期化時にも高さを調整する
//adjustTopImageHeight();


//コラムSwiper
const swiperSlides = document.getElementsByClassName('column-slide');
const breakPoint = 600;
let mySwiper ;
let mySwiperBool ;


window.addEventListener('load',()=>{
  if( breakPoint < window.innerWidth){
    mySwiperBool = false;
  }else{
    createSwiper();
    mySwiperBool = true;
  }
},false);

window.addEventListener('resize',()=>{
  if( breakPoint < window.innerWidth && mySwiperBool){
    mySwiper.destroy(false,true);
    mySwiperBool = false;
  }else if( breakPoint >= window.innerWidth && !(mySwiperBool)){
    createSwiper();
    mySwiperBool = true;
  }
},false);

const createSwiper = () =>{
  columnSlider = new Swiper('.columnSlider',{
    //speed: 1500,
    //autoplay: {
      //delay: 2000
    //},
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    slideToClickedSlide: true,
    spaceBetween: 12,
    slidesPerView: 'auto',
    loop: false,
    loopedSlides: swiperSlides.length,
    centeredSlides: true,
    slidesPerView: 1.3
  });
}